import { useMemo } from 'react';
import { observer } from 'mobx-react-lite';
import moment from 'moment';

import {
  TEntityGridConstraints,
  TEntityGridExtraFilter,
} from 'app/common/entity-grid/core';
import * as EntityGrid from 'app/common/entity-grid/features';
import { HotFixEntityGridReadRequest } from 'app/common/entity-grid/features/entity-grid';
import { StringFilterDataGrid } from 'app/common/ui/data-grid/filters';
import { RangeDateFilterModel } from 'app/common/ui/data-grid/filters/range-date/core';
import { HttpRequest } from 'app/libs/http-client';
import { useUserRoles } from 'app/railways/domains/access/features/roles/use-user-roles';

import { TEventsConstraints } from '../../core/events-constraints';
import { getEventsRequest } from '../../requests';
import { cols } from './events-entity-grid-columns';

const extraFilters: TEntityGridExtraFilter[] = [
  {
    header: 'ID объекта',

    component: StringFilterDataGrid({ filterName: 'resourceId' }),
  },
];

export const EventsEntityGrid = observer(() => {
  const userRoles = useUserRoles();
  const DATE_COLUMN_NAME = 'date';
  const mapRequestParams = (constraints?: TEventsConstraints): HttpRequest => {
    const filters = { ...constraints?.filter };

    // map data grid RangeDateFilter Value to Server API Filter
    if (DATE_COLUMN_NAME in filters) {
      const rangeFilter = filters[
        DATE_COLUMN_NAME
      ] as RangeDateFilterModel['value'];

      filters['lowDate'] = rangeFilter.start.toJSON();
      filters['highDate'] = rangeFilter.end.toJSON();

      delete filters[DATE_COLUMN_NAME];
    }

    const updatedConstraints: TEventsConstraints = {
      ...constraints,
      sorting: constraints?.sorting || [],
      filter: filters,
    };

    return getEventsRequest(updatedConstraints);
  };

  const initialConstraints = useMemo<TEntityGridConstraints>(
    () => ({
      sorting: [{ name: 'id', direction: 'descend' }],
      filter: {
        [DATE_COLUMN_NAME]: {
          start: moment().subtract(7, 'days').startOf('day').toDate(),
          end: moment().endOf('day').toDate(),
        },
      },
    }),
    [],
  );

  return (
    <EntityGrid.Root
      columns={cols}
      rowModelType="largeList"
      recordsLimit={1000}
      initialState={initialConstraints}
      request={mapRequestParams}
      userRoles={userRoles}
      extraFilters={extraFilters}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 16,
          padding: 16,
          height: '100%',
        }}
      >
        <EntityGrid.NotificationsRender>
          {(notifications) => <div>{notifications}</div>}
        </EntityGrid.NotificationsRender>

        <HotFixEntityGridReadRequest />

        <div style={{ flexGrow: 1 }}>
          <EntityGrid.Table
            rowSelection="multiple"
            persistSettingsId="TripsOrdersEntityGrid"
          />
        </div>
      </div>
    </EntityGrid.Root>
  );
});
